import React from 'react';
import {ReactNode} from 'react';
import {ToastContextObject} from '@zvne/fe-framework/dist/presentation/toast/toast-context';
import {makeStringComponent} from '@zvne/fe-framework/dist/presentation/language/strings';
import {strings} from './strings';

const Str = makeStringComponent(strings);

export function handleApiError(toast: ToastContextObject, error: any) {
    if (error.response) {
        const response = error.response;
        console.error(response);
        if (response.data != null &&
            typeof response.data === 'object' &&
            typeof response.data.message === 'string') {
            toast.error(response.data.message);
        } else if (response.status === 400) {
            toastErrorWithStatus(toast, <Str k={'status400'}/>, response.status);
        } else if (response.status === 401) {
            toastErrorWithStatus(toast, <Str k={'status401'}/>, response.status);
        } else if (response.status === 403) {
            toastErrorWithStatus(toast, <Str k={'status403'}/>, response.status);
        } else if (response.status === 404) {
            toastErrorWithStatus(toast, <Str k={'status404'}/>, response.status);
        } else if (response.status >= 500 && response.status < 600) {
            toastErrorWithStatus(toast, <Str k={'status5xx'}/>, response.status);
        } else {
            toastErrorWithStatus(toast, <Str k={'statusXxx'}/>, response.status);
        }
    } else if (error.request) {
        toast.error(<Str k={'noResponse'}/>);
        console.error(error.request);
    } else {
        toast.error(<Str k={'noRequest'}/>);
        console.error(error);
    }
}

function toastErrorWithStatus(toast: ToastContextObject, message: ReactNode, statusCode: number): void {
    toast.error(
        <>
            {message} (<Str k={'statusCode'}/>: {statusCode})
        </>
    );
}
